import defaultImg from "../../../assets/images/default_profile_img.png";
import { ChatType } from "../../../util/ChatUtils";

const ChatUserCard = ({ chat, onClick, currentChat }) => {
    const sentTime = chat?.lastMessageAt ? new Date(chat?.lastMessageAt).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }) : '';


    return (
        <div className={(currentChat?.chatId && currentChat?.chatId === chat.chatId) ? 'sm_chat_user_card_body current' : 'sm_chat_user_card_body'} onClick={onClick}>
            <div className='sm_chat_user_card_info'>
                {Number(chat?.unReadMsg ?? 0) > 0 && (
                    <p className="sm_chat_message_unread_message_badge">
                        {chat.unReadMsg}
                    </p>
                )}
               {chat?.chatType == ChatType.GROUP && <img src={chat?.groupProfileImg ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${chat?.groupProfileImg}` : defaultImg} alt="" />}
               {chat?.chatType == ChatType.PRIVATE && <img src={chat?.privateChatImage ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${chat?.privateChatImage}` : defaultImg} alt="" />}
                <div className='sm_chat_user_card_name_submessage'>
                    {chat?.chatType == ChatType.GROUP ?
                        <>
                            <h4>{chat?.groupName}</h4>
                            <h5>{chat?.lastMessage}</h5>
                        </>
                        : <>
                            <h4>{chat?.privateChatName}</h4>
                            <h5>{chat?.lastMessage}</h5>
                        </>}
                </div>
            </div>
            <p>
                {sentTime}
            </p>
        </div>
    )
}

export default ChatUserCard
